export default __webpack_public_path__ + "static/banner-header25-6abeaa5c9d123b6a7e69b3c81cac4086.png";